export default "__VITE_ASSET__DjTdC6DS__"